module.exports = __webpack_public_path__ + "flutter.3aedd0.svg";